import { Injectable } from '@angular/core';
import { map, finalize } from 'rxjs/operators';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { Order } from '../shared/order.interface';
import { ProductI } from '../shared/product.interface';
import { FileI } from '../shared/file.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductosService {

  private productosCollection: AngularFirestoreCollection<ProductI>;

  updateProdList = false;

  compras: any;
  cantCompras$: Observable<any>;

  // carga de productos por categoria
  categoria: string;
  // búsqueda desde barra
  termino: string;

  // barra cookies
  ckies = true;

  private filePath: any;
  private downloadURL: string;

  constructor(private db: AngularFirestore,
              private storage: AngularFireStorage) {
   this.productosCollection = db.collection<ProductI>('productos');
   this.loadStorageSalesCarShop();
  }

  filterProd(producto: ProductI, image: FileI){
    this.uploadImage(producto, image);
  }
  private uploadImage(producto: ProductI, image: FileI){
    this.filePath = `productos/${image.name}`;
    const fileRef = this.storage.ref(this.filePath);
    const task = this.storage.upload(this.filePath, image);
    task.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe( urlImage => {
          this.downloadURL = urlImage;
          this.agregarProductos(producto);
        });
      })
    ).subscribe();
 }

 agregarProductos(producto: ProductI){
  const prodObj = {
    categoria: producto.categoria,
    solucion: producto.solucion,
    imagen: this.downloadURL,
    nombre: producto.nombre,
    cantidad: producto.cantidad,
    precio: producto.precio,
    presentacion: producto.presentacion,
    uso: producto.uso,
    fechaCreacion: producto.fechaCreacion,
    fileRef: this.filePath,
    beneficios: producto.beneficios,
    descripcion: producto.descripcion,
    descuento: producto.descuento,
    estado: producto.estado
  };
  if (producto.id) {
    return this.productosCollection.doc(producto.id).update(prodObj);
  } else {
    return this.productosCollection.add(prodObj);
  }
}

updateProductById(producto: ProductI, newImage?: FileI){
  if (newImage) {
    this.uploadImage(producto, newImage);
  } else {
    return this.productosCollection.doc(producto.id).update(producto);
  }
}

corregirPrecio(idProd: string, precio: number){
  return this.productosCollection.doc(idProd).update({precio: precio});
}

deleteProductById(producto: ProductI) {
  return this.productosCollection.doc(producto.id).delete();
}

getProductById(id: string){
  return this.productosCollection.doc(id).valueChanges();
}

loadCategoriesIndex(){
  return this.db.collection('categorias', ref => ref
                .where('estado', '==', 'Activado').limit(9))
                .valueChanges();

                /* return this.db.collection('categorias', ref => ref
                .where('estado', '==', 'Activado'))
                .valueChanges(); */
}
loadCategories(){
  return this.db.collection('categorias', ref => ref
                .where('estado', '==', 'Activado'))
                .snapshotChanges()
                .pipe(
                  map(actions =>
                    actions.map(resp => {
                      const data = resp.payload.doc.data() as any;
                      const id = resp.payload.doc.id;
                      return {id, ...data};
                    }))
                );
}
loadCategoriesAdmin(){
    return this.db.collection('categorias', ref => ref
                  .orderBy('orden', 'asc'))
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                       const data = resp.payload.doc.data() as any;
                       const id = resp.payload.doc.id;
                       return {id, ...data};
                     }))
                  );
  }

loadAllProducts(){
    return this.db.collection('productos', ref => ref
                  .orderBy('nombre', 'asc'))
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                       const data = resp.payload.doc.data() as any;
                       const id = resp.payload.doc.id;
                       return {id, ...data};
                     }))
                  );
  }
  loadAllProductsActivate(){
    return this.db.collection('productos', ref => ref
                  .where('estado','==', 'Activado'))
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                       const data = resp.payload.doc.data() as any;
                       const id = resp.payload.doc.id;
                       return {id, ...data};
                     }))
                  );
  }

  loadProductByCategory(cat: string){
    return this.db.collection('productos', ref => ref
    .where('categoria'[0], '==', cat)
    .where('estado', '==', 'Activado'))
    .snapshotChanges()
    .pipe(
      map(actions =>
       actions.map(resp => {
         const data = resp.payload.doc.data() as any;
         const id = resp.payload.doc.id;
         return {id, ...data};
       }))
    );
  }
  loadProductById(id: string){
   return this.db.collection('productos').doc(id).valueChanges();
  }
  loadProductsForPrice(precio: number){
    return this.db.collection('productos', ref => ref
                  .where('precio', '<=', precio))
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                       const data = resp.payload.doc.data() as any;
                       const id = resp.payload.doc.id;
                       return {id, ...data};
                     }))
                  );
  }
  cargarPedido(order: Order){
    return this.db.collection('carShop').add(order);
  }

  activarProducto(idProd: string){
    return this.db.collection('productos').doc(idProd).update({estado: 'Activado'});
  }
  desactivarProducto(idProd: string){
    return this.db.collection('productos').doc(idProd).update({estado: 'Desactivado'});
  }

  activarCategoria(idCat: string){
    return this.db.collection('categorias').doc(idCat).update({estado: 'Activado'});
  }
  desactivarCategoria(idCat: string){
    return this.db.collection('categorias').doc(idCat).update({estado: 'Desactivado'});
  }
  ordenCategoria(idCat: string, nuevoOrden: number){
    return this.db.collection('categorias').doc(idCat).update({orden: nuevoOrden});
  }

  loadStorageSalesCarShop(){
    if (localStorage.getItem('dataCarShopTorreonMarket')) {
      this.compras = JSON.parse( localStorage.getItem('dataCarShopTorreonMarket'));
      this.cantCompras$ = this.compras.length;
    }
  }
}
